<template>
  <template v-for="option in tree" :key="option.code">
    <Option :value="option.code">{{ option.name }}</Option>
    <div class="child-option" v-if="option.children && option.children.length > 0">
      <dict-option :tree="option.children"/>
    </div>
  </template>
</template>
<script>
import DictOption from './DictOption'
export default {
  name: 'DictOption',
  props: {
    tree: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
    }
  },
  computed: {
  },
  methods: {
  },
  components: {
    DictOption,
  }
}
</script>
